import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { CreditDebitNoteItem } from "../../types/credit-debit-note.type";
import { formatNumber } from "../../utils";

/** A stored note's lines, as the server resolved and priced them, with what each put back into stock. */
export default function NoteItemsTable({ items }: Readonly<{ items: CreditDebitNoteItem[] }>) {
  const hasStockReturn = items.some((item) => item.return_qty !== null);

  return (
    <TableContainer>
      <Table size="small">
        <TableHead sx={{ bgcolor: (theme) => theme.palette.background.default }}>
          <TableRow>
            <TableCell width={48}>#</TableCell>
            <TableCell>สินค้า</TableCell>
            <TableCell>บาร์โค้ด</TableCell>
            <TableCell align="right">จำนวน</TableCell>
            <TableCell align="right">ราคา/หน่วย</TableCell>
            <TableCell align="right">ส่วนลด</TableCell>
            <TableCell align="right">จำนวนเงิน</TableCell>
            {hasStockReturn && <TableCell align="right">คืนเข้าสต็อก</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.uuid}>
              <TableCell>{item.line_no}</TableCell>
              <TableCell>
                <Typography variant="body2">{item.product_name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.product_code}
                </Typography>
              </TableCell>
              <TableCell>{item.barcode ?? "-"}</TableCell>
              <TableCell align="right">
                {formatNumber(item.qty, { decimals: 0 })} {item.unit ?? ""}
              </TableCell>
              <TableCell align="right">{formatNumber(item.unit_price)}</TableCell>
              <TableCell align="right">{formatNumber(item.discount_amount)}</TableCell>
              <TableCell align="right">{formatNumber(item.line_total)}</TableCell>
              {hasStockReturn && (
                <TableCell align="right">{formatNumber(item.return_qty, { decimals: 0 })}</TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
